import React, { useState, useCallback } from 'react';
import { DrawerContext } from './DrawerContext';
import AppDrawer from './AppDrawer';

// Owns the slide-in drawer's state and renders <AppDrawer> once, at a level
// ABOVE the routed pages. This matters: pages like ManageLocations call
// useDrawer() in their own body and then render <AdminShell> as a child.
// A hook reads context from a Provider that is its ANCESTOR — so if the
// Provider lived inside AdminShell (a descendant of the page), useDrawer()
// would resolve to the no-op default and every in-page "Add"/"Edit" button
// would silently do nothing. Wrapping the router with this provider makes the
// pages descendants, so useDrawer() returns the real openDrawer/closeDrawer.
export default function DrawerProvider({ children }) {
    const [open, setOpen]       = useState(false);
    const [content, setContent] = useState(null);
    const [title, setTitle]     = useState('');

    const openDrawer = useCallback((c, t) => {
        setContent(c);
        setTitle(t);
        setOpen(true);
    }, []);

    const closeDrawer = useCallback(() => setOpen(false), []);

    return (
        <DrawerContext.Provider value={{ openDrawer, closeDrawer }}>
            {children}
            <AppDrawer open={open} title={title} onClose={closeDrawer}>
                {open && content}
            </AppDrawer>
        </DrawerContext.Provider>
    );
}
